// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9c776b0e","977":"0c08515b"}[chunkId] + ".chunk.js";
};